export const unsubscribeAsk = "UNLQBd";
export const suggestedUnsubscribeReason = "MYBrq";
export const deleteAllCheckboxLabel = "HNwxwd";
export const noThankYou = "Ywxgjc";
export default {unsubscribeAsk,suggestedUnsubscribeReason,deleteAllCheckboxLabel,noThankYou};